<template>
    <div>
        <div v-if="!selectedFridge">
            Холодильник не выбран
        </div>
        <div v-if="selectedFridge">
            <div>
                <button class="btn btn-success lock-btn" @click="openLock()">Открыть замок</button>
                <button class="btn btn-danger lock-btn" @click="closeLock()">Закрыть замок</button>
            </div>

            <last-error-block></last-error-block>

            <div class="status-block">
                <div v-if="isWaitingAnswer">
                    Ожидание первого ответа...
                </div>

                <div>
                    Статус:
                    <span class="status status-unknown" v-if="isLockOpened === null">Неизвестно</span>
                    <span class="status status-opened" v-if="isLockOpened === true">Открыт</span>
                    <span class="status status-closed" v-if="isLockOpened === false">Закрыт</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import fridgeRabbit from "../utils/rabbit/fridge_rabbit";
    import LastErrorBlock from "../components/LastErrorBlock";


    export default {
        name: "TestLock",
        components: {LastErrorBlock},
        computed: {
            ...mapState('app', {
                selectedFridge: 'selectedFridge',
            }),
            isWaitingAnswer() {
                return this.response === null;
            },
            isLockOpened() {
                if(this.response && this.response.lock_opened !== undefined) {
                    return !!this.response.lock_opened;
                }

                return null;
            },
        },
        methods: {
            ...mapActions('app', {
                setLastError: 'setLastError',
                clearLastError: 'clearLastError',
            }),
            checkLock() {
                this.response = null;
                fridgeRabbit.send('check_lock');
            },
            openLock() {
                this.response = null;
                fridgeRabbit.send('open_lock');
            },
            closeLock() {
                this.response = null;
                fridgeRabbit.send('close_lock');
            },
            onAnswer(data) {
                if(!data) {
                    return;
                }

                if(!data.success) {
                    this.setLastError(data.error);
                } else {
                    this.clearLastError();
                }

                this.response = data;
            },
        },
        data() {
            return {
                response: null,
            };
        },
        async mounted() {
            await fridgeRabbit.listen(this.onAnswer);
            this.checkLock();
        },
        destroyed() {
            fridgeRabbit.clear();
            this.clearLastError();
        },
    }
</script>

<style scoped>
    .btn {
        margin: 5px auto;
        width: 100%;
    }

    .status-block {
        text-align: center;
        margin: 20px auto;
    }
    .status {
        font-weight: bold;
    }
    .status-opened {
        color: green;
    }
    .status-closed {
        color: red;
    }
    .status-unknown {
        color: black;
    }
    .lock-btn {
        width: 50%;
    }
</style>
